module.exports = __webpack_public_path__ + "img/Group1370@2x.baf17444.png";